import routes from './routes'

export const slug = 'itinerary'
export { routes }
